<div>
  <div *ngIf="viewMode !== 'plate' && viewMode !== 'new-dropdown'"
       class="rounded-lg border border-1 py-4 px-3 w-100 mx-auto mt-4"
       style="background-color: #F1F4F2; border-color: #969696; max-width: 600px">
    <div class="px-0 px-md-2 mt-0 w-100 mx-auto">
      <div class="px-4 px-md-3">
        <div class="mx-auto">
          <p class="mb-2 lh-sm fw-normal fs-md-14 fs-mb-13">Select a start or ending to see results</p>
        </div>
        <div class="mx-auto d-flex align-items-center justify-content-between gap-3">

          <div class="w-100">
            <mat-form-field *ngIf="viewMode === 'autocomplete'" appearance="outline" class="w-100">
              <mat-label>Select a start</mat-label>
              <input type="text" matInput [matAutocomplete]="prefixAutoComplete" [(ngModel)]="prefixFilter">
              <mat-autocomplete #prefixAutoComplete="matAutocomplete" (optionSelected)="RawOptionChange(true, $event)"
                                [disableRipple]="true">
                <mat-option *ngFor="let option of getOptions(true)" [value]="option.value">{{ option.view }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <pla-custom-dropdown *ngIf="viewMode === 'custom-dropdown'" [justify]="'justify-content-start'"
                                 [baseClass]="'bg-white border border-1'"
                                 [closedClass]="'rounded-3 border'" [showBullet]="true" [openedClass]="
                    'rounded-top-3 border-start border-top border-end border-bottom-transparent'
                  " [optionClass]="
                    'border-1 border border-dark border-start border-end border-bottom rounded-bottom-3 overflow-hidden'
                  " [config]="prefixOptions" (change)="OptionChange(true, $event)"
                                 [forceSelect]="changePrefixDropdown"></pla-custom-dropdown>
          </div>

          <div class="w-100">
            <mat-form-field *ngIf="viewMode === 'autocomplete'" appearance="outline" class="w-100">
              <mat-label>Select an ending</mat-label>
              <input type="text" matInput [matAutocomplete]="suffixAutoComplete" [(ngModel)]="suffixFilter">
              <mat-autocomplete #suffixAutoComplete="matAutocomplete" (optionSelected)="RawOptionChange(false, $event)"
                                [disableRipple]="true">
                <mat-option *ngFor="let option of getOptions(false)" [value]="option.value">{{ option.view }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <pla-custom-dropdown *ngIf="viewMode === 'custom-dropdown'" [justify]="'justify-content-start'"
                                 [baseClass]="'bg-white border border-1'"
                                 [closedClass]="'rounded-3 border'" [showBullet]="true" [openedClass]="
                    'rounded-top-3 border-start border-top border-end border-bottom-transparent'
                  " [optionClass]="
                    'border-1 border border-dark border-start border-end border-bottom rounded-bottom-3 overflow-hidden'
                  " [config]="suffixOptions" (change)="OptionChange(false, $event)"
                                 [forceSelect]="changeSuffixDropdown"></pla-custom-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="viewMode === 'new-dropdown'" class="container-fluid px-0">

    <div class="row">
      <div class="col-12 col-md-7 {{ searchByPrefix ? 'order-1 order-md-0' : 'order-0 order-md-1' }}">
        <div class="container-fluid px-0">
          <div class="row">
            <p class="fw-bolder fs-6">{{searchByPrefix ? '1' : '2'}}. Choose a {{ searchByPrefix ? 'prefix' : 'suffix' }}</p>
          </div>
          <div class="row">
            <ng-container *ngFor="let option of lengthOptions(searchByPrefix, 4)">
              <div class="col-6 col-md-4">
                <pla-plate [rawPlate]="option.view + '___'" [showPrice]="false" [changeHover]="false"
                           [mobileSmall]="true" [customClass]="'flat shaded mb-3'" [plateSize]="'ns-s'"
                           [smallPlate]="false" [clickThrough]="false"
                           [showPercentage]="false" [noMargin]="true" [white]="option.view === selectedPrefix"
                           [selected]="option.view === selectedPrefix" [termFirst]="false"
                           [showIndex]="false" (customAction)="PlateOptionChange(searchByPrefix, $event, false)"></pla-plate>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-5 {{ searchByPrefix ? 'order-0 order-md-1' : 'order-1 order-md-0' }}">
        <p class="fw-bolder fs-6">{{searchByPrefix ? '2' : '1'}}. Pair with a {{ searchByPrefix ? 'suffix' : 'prefix' }}</p>
        <div class="border rounded-3 p-2" style="background: #FCFEFF">
          <div class="plate-background flat shaded">
            <div class="d-flex align-items-center justify-content-center gap-2 px-2 px-md-4 py-2 py-md-2">
              <div *ngIf="searchByPrefix">
                <p class="my-0  plate-font fs-mb-20 fs-md-28">{{ selectedPrefix }}</p>
              </div>
              <div *ngIf="searchByPrefix">
                <pla-custom-dropdown *ngIf="selectedPrefix" [justify]="'justify-content-start'"
                                     [baseClass]="'bg-transparent border border-dark border-1 plate-font'"
                                     [closedClass]="'rounded-3 border'" [showBullet]="false" [showIcon]="false" [plateFont]="true"
                                     [fontSizeClass]="'fs-mb-20 fs-md-28'" [openedClass]="
                      'rounded-top-3 border-start border-top border-end border-bottom-transparent'
                    " [optionClass]="
                      'border-1 border border-dark border-start border-end border-bottom rounded-bottom-3 overflow-hidden plate-font'
                    " [config]="suffixConfig(7 - selectedPrefix.length)" (change)="OptionChange(!searchByPrefix, $event, false)"
                                     [forceSelect]="changeSuffixDropdown"></pla-custom-dropdown>
              </div>

              <div *ngIf="!searchByPrefix">
                <pla-custom-dropdown *ngIf="selectedSuffix" [justify]="'justify-content-start'"
                                     [baseClass]="'bg-transparent border border-dark border-1 plate-font'"
                                     [closedClass]="'rounded-3 border'" [showBullet]="false" [showIcon]="false" [plateFont]="true"
                                     [fontSizeClass]="'fs-mb-20 fs-md-28'" [openedClass]="
                      'rounded-top-3 border-start border-top border-end border-bottom-transparent'
                    " [optionClass]="
                      'border-1 border border-dark border-start border-end border-bottom rounded-bottom-3 overflow-hidden plate-font'
                    " [config]="prefixConfig(7 - selectedSuffix.length)" (change)="OptionChange(!searchByPrefix, $event, false)"
                                     [forceSelect]="changePrefixDropdown"></pla-custom-dropdown>
              </div>
              <div *ngIf="!searchByPrefix">
                <p class="my-0  plate-font fs-mb-20 fs-md-28">{{ selectedSuffix }}</p>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-4"
                 *ngIf="showPrices && selectedPlate() && selectedPlate().registration && selectedPlate().registration.length === 7">
              <pla-tp-sellers (PriceRangeChange)="PriceRangeChange($event)" [useCachedResults]="true"
                              [onlyShowLoader]="true"
                              [registration]="selectedPlate().registration"></pla-tp-sellers>

              <div *ngIf="detail && detail.min > 0" class="text-center mt-0 mb-4">
                <p class="text-center mt-0 mb-0" *ngIf="detail.min !== 0">
                  Prices From
                </p>
                <p class="mb-0" *ngIf="detail.min !== 0 && detail.min != detail.max">
                  <strong class="fs-5">{{
                      detail.min | currency : "GBP"
                    }}</strong>
                  to
                  <strong class="fs-5">{{
                      detail.max | currency : "GBP"
                    }}</strong>
                </p>
                <p class="mb-0" *ngIf="detail.min !== 0 && detail.min == detail.max">
                  <strong class="fs-5">{{
                      detail.min | currency : "GBP"
                    }}</strong>
                </p>
                <small class="text-muted">Details last updated on
                  {{ detail.lastUpdate | date : "dd/MM/yy" }}</small>
              </div>

              <div class="d-flex align-items-center justify-content-around">
                <pla-inline-favourite [force]="'favourite'"
                                      [plate]="selectedPlate()"></pla-inline-favourite>

                <pla-inline-plate-viewer-link [plate]="selectedPlate()"></pla-inline-plate-viewer-link>

                <div class="d-flex align-items-center justify-content-start ps-0 ps-md-1">
                  <button (click)="openPlateDetail()" style="min-height: 28px;"
                          class="platex-button w-100 d-none d-sm-flex align-items-center justify-content-center gap-1 rounded-3 py-1 px-2">
                    <span class="fs-md-14 fw-normal lh-1">View</span>
                  </button>
                  <mat-icon data-nosnippet (click)="openPlateDetail()" class="d-block d-sm-none">
                    chevron_right
                  </mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="viewMode === 'plate'" class="">
    <!-- chips -->
    <pla-sticky-tabs class="flex-fill w-100" [config]="stickyLinkConfig" [classes]="'pt-3 pb-3'"></pla-sticky-tabs>

    <!-- selector -->
    <div class="container-fluid">
      <div class="row">

        <ng-container *ngIf="visibleOptions === 'three-letter-prefix'">
          <ng-container *ngFor="let option of lengthOptions(true, 3)">
            <div class="col-6 col-md-3 col-xl-2">
              <pla-plate [rawPlate]="option.view" [showPrice]="false" [changeHover]="false"
                         [mobileSmall]="true" [customClass]="'flat shaded mb-3'" [plateSize]="'ns-s'"
                         [smallPlate]="false" [clickThrough]="false"
                         [showPercentage]="false" [noMargin]="true" [white]="option.view === selectedPrefix"
                         [selected]="option.view === selectedPrefix" [termFirst]="false"
                         [showIndex]="false" (customAction)="PlateOptionChange(true, $event)"></pla-plate>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="visibleOptions === 'four-letter-prefix'">
          <ng-container *ngFor="let option of lengthOptions(true, 4)">
            <div class="col-6 col-md-3 col-xl-2">
              <pla-plate [rawPlate]="option.view" [showPrice]="false" [changeHover]="false"
                         [mobileSmall]="true" [customClass]="'flat shaded mb-3'" [plateSize]="'ns-s'"
                         [smallPlate]="false" [clickThrough]="false"
                         [showPercentage]="false" [noMargin]="true" [white]="option.view === selectedPrefix"
                         [selected]="option.view === selectedPrefix" [termFirst]="false"
                         [showIndex]="false" (customAction)="PlateOptionChange(true, $event)"></pla-plate>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="visibleOptions === 'four-letter-suffix'">
          <ng-container *ngFor="let option of lengthOptions(false, 4)">
            <div class="col-6 col-md-3 col-xl-2">
              <pla-plate [rawPlate]="option.view" [showPrice]="false" [changeHover]="false"
                         [mobileSmall]="true" [customClass]="'flat shaded mb-3'" [plateSize]="'ns-s'"
                         [smallPlate]="false" [clickThrough]="false"
                         [showPercentage]="false" [noMargin]="true" [white]="option.view === selectedSuffix"
                         [selected]="option.view === selectedPrefix" [termFirst]="false"
                         [showIndex]="false" (customAction)="PlateOptionChange(false, $event)"></pla-plate>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="row"
           *ngIf="hasMore(visibleOptions.indexOf('prefix') > -1, visibleOptions.indexOf('three') === -1 ? 4 : 3)">
        <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
          <div class="w-100" style="height: 1px; background-color: #DEDEDE;"></div>

          <div (click)="PageIncrease()" class="mx-auto d-block rounded-pill px-3 py-1 text-center"
               style="background-color: #4D818E; user-select: auto;pointer-events: all;cursor: pointer; min-width: 150px;">
            <p class="my-0 text-white lh-1">See More</p>
          </div>

          <div class="w-100" style="height: 1px; background-color: #DEDEDE;"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4 rounded-3 px-3 py-2" style="background: #F4F5F4" *ngIf="viewMode === 'new-dropdown'">
    <p class="fw-bolder fs-6">Plato AI Suggests</p>

    <ng-container *ngIf="loading">
      <div
        class="d-flex align-items-center justify-content-evenly justify-content-md-between gap-3 flex-wrap px-0 mb-3">
        <ng-template *ngFor="let item of [].constructor(16)" [ngTemplateOutlet]="loadingPlate"></ng-template>
      </div>
    </ng-container>

    <!-- RESULTS-->
    <div
      class="d-flex align-items-center justify-content-evenly justify-content-md-between gap-3 flex-wrap px-0 mb-3">
      <ng-container *ngFor="let plate of results.slice(0, 4)">
        <div class="bg-white">
          <ng-template [ngTemplateOutlet]="plateRow" [ngTemplateOutletContext]="{ plate: plate }"></ng-template>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mt-4" *ngIf="viewMode !== 'new-dropdown'">
    <ng-container *ngIf="loading">
      <div
        class="d-flex align-items-center justify-content-evenly justify-content-md-between gap-3 flex-wrap px-0 mb-3">
        <ng-template *ngFor="let item of [].constructor(16)" [ngTemplateOutlet]="loadingPlate"></ng-template>
      </div>
    </ng-container>

    <!-- RESULTS-->
    <div
      class="d-flex align-items-center justify-content-evenly justify-content-md-between gap-3 flex-wrap px-0 mb-3">
      <ng-container *ngFor="let plate of results">
        <ng-template [ngTemplateOutlet]="plateRow" [ngTemplateOutletContext]="{ plate: plate }"></ng-template>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loadingPlate>
  <div
    class="d-flex align-items-center justify-content-center flex-column flex-fill border rounded p-2 plate-result-container skeleton">
    <div class="w-100 mx-auto" style="max-width: 230px">
      <div class="w-100 d-flex align-items-center justify-content-between mb-2 mx-auto">
        <div style="width: 30px; height: 30px"></div>
        <a
          class="skeleton-item fw-bolder my-0 text-truncate lh-sm text-decoration-none fs-md-14 lh-sm d-block w-100 text-center mx-auto"
          style="max-width: fit-content; color: transparent">LOADING</a>
        <div class="" style="width: 30px; height: 30px"></div>
      </div>
      <div class="">
        <pla-plate [loading]="true" [showPrice]="false" [changeHover]="false" [mobileSmall]="true"
                   [customClass]="'flat shaded'" [plateSize]="'nr-s'" [smallPlate]="false" [showPercentage]="false"
                   [noMargin]="true" [white]="false" [termFirst]="false" [showIndex]="false"
                   [showSoldRibbon]="false"></pla-plate>
      </div>
      <div class="d-flex mx-auto w-100 mt-2 mb-0 align-items-center justify-content-between">
        <span class="skeleton-item flex-fill rounded-3 p-1 fs-md-12 w-100 lh-sm"
              style="line-height: 30px; color: transparent">£ LOADING</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #plateRow let-plate="plate">
  <div
    class="d-flex align-items-center justify-content-center flex-column flex-fill border rounded p-2 plate-result-container">
    <div class="w-100 mx-auto" style="max-width: 230px">
      <div class="w-100 d-flex align-items-center justify-content-between mb-2 mx-auto">
        <div style="width: 30px; height: 30px"></div>

        <a routerLink="/search-results/{{ plate.term }}"
           class="fw-bolder my-0 text-truncate lh-sm text-decoration-none fs-md-14 lh-sm d-block w-100 text-center {{
            plate.owner == -1 ? 'text-muted' : 'text-dark'
          }}">{{ plate.term }}</a>

        <div *ngIf="plate.owner == 3" class="" style="width: 30px; height: 30px; max-height: 30px">
          <div class="svg-icn d-block w-100" style="max-height: 30px">
            <svg xmlns="http://www.w3.org/2000/svg" class="d-block w-100" width="30" height="30"
                 viewBox="0 0 103.604 103.604">
              <path id="currency_pound_24dp_FILL0_wght400_GRAD0_opsz24" class="tofill"
                    d="M240-835.84v-2.612l.634-.326a7.5,7.5,0,0,0,1.383-.963,6.814,6.814,0,0,0,1.363-1.632,4.293,4.293,0,0,0,.615-2.3,3.941,3.941,0,0,0-.058-.686q-.058-.326-.134-.62H240v-2.612h2.3q-.807-1.078-1.555-2.269a5.452,5.452,0,0,1-.749-2.955,6.448,6.448,0,0,1,2.458-5.093A8.937,8.937,0,0,1,248.449-860a9.188,9.188,0,0,1,4.839,1.273,7.418,7.418,0,0,1,3.034,3.3l-2.842,1.012a4.732,4.732,0,0,0-1.939-2.138,5.813,5.813,0,0,0-3.092-.833,5.674,5.674,0,0,0-3.8,1.339,4.1,4.1,0,0,0-1.575,3.232,3.8,3.8,0,0,0,.922,2.612,18.843,18.843,0,0,1,1.882,2.612h6.414v2.612h-5.338a3.187,3.187,0,0,1,.1.62q.019.326.019.686a6.327,6.327,0,0,1-.672,2.938,9.348,9.348,0,0,1-1.632,2.285h7.528a3.525,3.525,0,0,0,2.343-.686,3.523,3.523,0,0,0,1.114-1.763l2.688,1.143a4.475,4.475,0,0,1-2.17,2.857,7.506,7.506,0,0,1-3.975,1.061Z"
                    transform="translate(-197.416 904.142)" fill="#007850"/>
              <g id="restart_alt_24dp">
                <g id="Group_1932" data-name="Group 1932">
                  <path id="Path_962" data-name="Path 962" d="M0,0H103.6V103.6H0Z" fill="none"/>
                </g>
                <g id="Group_1934" data-name="Group 1934" transform="translate(17.267 10.792)">
                  <g id="Group_1933" data-name="Group 1933">
                    <path id="Path_963" data-name="Path 963" class="tofill"
                          d="M12.634,47.827a25.811,25.811,0,0,1,7.6-18.3l-6.13-6.13A34.531,34.531,0,0,0,34.218,82.059v-8.72A25.93,25.93,0,0,1,12.634,47.827Zm60.435,0A34.525,34.525,0,0,0,38.535,13.292c-.259,0-.518.043-.777.043L42.463,8.63,36.376,2.5,21.267,17.609,36.376,32.718l6.087-6.087L37.8,21.969c.259,0,.518-.043.734-.043a25.887,25.887,0,0,1,4.317,51.413v8.72A34.485,34.485,0,0,0,73.069,47.827Z"
                          transform="translate(-4 -2.5)" fill="#007850"/>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div *ngIf="plate.owner != 3" class="" style="width: 30px; height: 30px"></div>
      </div>
      <div>
        <pla-plate [plate]="plate" [showPrice]="false" [changeHover]="false" [hoverText]="plate.term"
                   [mobileSmall]="true" [customClass]="'flat shaded'" [plateSize]="'nr-s'" [smallPlate]="false"
                   [showPercentage]="false" [noMargin]="true" [disabled]="plate.owner == -1" [white]="false"
                   [termFirst]="false"
                   [showIndex]="false" [secondaryText]="plate.formattedRegistration"
                   [showSoldRibbon]="false"></pla-plate>
      </div>
      <div class="d-flex mx-auto w-100 mt-2 mb-0 align-items-center justify-content-between">

        <span class="flex-fill rounded-3 p-1 fs-md-12 w-100 lh-sm" style="line-height: 30px"
              *ngIf="plate.owner != null && plate.owner > -2"
              [ngStyle]="{ color: plate.owner == -1 ? '#860202' : '#214953' }">{{ plate.owner == -1 ? "SOLD" : "FROM" }}
          {{ plate.price / 100 | currency : "GBP" : "symbol" : "1.0-0" }}</span>

        <span class="flex-fill rounded-3 p-1 fs-md-12 w-100 lh-sm" style="line-height: 30px" *ngIf="plate.owner == null"
              [ngStyle]="{ color: plate.owner == null ? '#860202' : '#214953' }">Un released</span>

        <!-- ACTIONS -->
        <div *ngIf="plate.owner <= -1 && plate.owner !== null"
             class="flex-shrink-0 d-flex align-items-center justify-content-end gap-1 pointer notify-btn px-1 rounded-2"
             [ngClass]="{ set: plate.notified }" (click)="notifyRegistration(plate)">
          <span>{{ plate.notified ? "Notified" : "Notify" }}</span>
        </div>
        <div *ngIf="plate.owner !== -1 && plate.owner !== null"
             class="flex-shrink-0 d-flex align-items-center justify-content-end gap-1 pointer favourite-icn px-0 rounded-2"
             [ngClass]="{ set: plate.favourite }" (click)="favouriteRegistration(plate)">
          <!-- <span>{{ plate.favourite ? 'Saved' : 'Save'}}</span> -->
          <mat-icon data-nosnippet class="small icon">{{
              plate.favourite ? "favorite" : "favorite_border"
            }}
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
</ng-template>
